import { color, interpolateHcl } from 'd3'
import { CONFLUENCY_COLORS } from '../constants'

// Culture status colors
export const EMPTY_CULTURE_COLOR = '#EAEAEA'
export const DEAD_CULTURE_COLOR = '#CCCCCC'
export const OVER_CONFLUENT_COLOR = '#FF8F4F'

function interpolateColor(colorOne: string, colorTwo: string, value: number) {
  const rgbString = color(interpolateHcl(colorOne, colorTwo)(value))

  if (rgbString) {
    return rgbString.formatHex()
  }

  return colorOne
}

// Stretch certain ranges out more according to IPSC_CULTURE_CONFLUENCY_DATASETS.
export function getConfluencyColor(confluency: number, forText = false) {
  if (confluency < 36 && forText) {
    return CONFLUENCY_COLORS[1]
  }
  if (confluency < 20) {
    return CONFLUENCY_COLORS[0]
  }
  if (confluency >= 20 && confluency < 36) {
    return interpolateColor(
      CONFLUENCY_COLORS[0],
      CONFLUENCY_COLORS[1],
      (confluency - 20) / 16,
    )
  }
  // IPSC_CULTURE_CONFLUENCY_DATASETS rarely has values here, so keep it one color.
  if (confluency >= 36 && confluency < 50) {
    return CONFLUENCY_COLORS[1]
  }
  if (confluency >= 50 && confluency < 58) {
    return interpolateColor(
      CONFLUENCY_COLORS[1],
      CONFLUENCY_COLORS[2],
      (confluency - 50) / 8,
    )
  }
  if (confluency >= 58 && confluency < 70) {
    return CONFLUENCY_COLORS[2]
  }
  if (confluency >= 70 && confluency < 80) {
    return CONFLUENCY_COLORS[3]
  }

  return CONFLUENCY_COLORS[4]
}
